module.exports = __webpack_public_path__ + "img/banner11.7da1e773.jpg";